<div class="form-group row">
    <label
        [ngClass]="
            labelSize === 0 ? 'd-none' : 'col-sm-' + labelSize + ' col-form-label col-form-label-sm'
        "
    >
        <i
            class="fas fa-exclamation text-danger"
            [hidden]="dateInput.valid"
            tooltip="{{ label }} is required"
        ></i>
        {{ label }}
    </label>
    <div [ngClass]="labelSize === 12 ? 'd-none' : 'col-md-' + (12 - labelSize) + ' form-group'">
        <date-input
            [(value)]="value"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [disabled]="disabled"
            #dateInput
            [required]="required"
        ></date-input>
    </div>
</div>
